import { render } from "./KakaoLogin.vue?vue&type=template&id=a46b63a2"
import script from "./KakaoLogin.vue?vue&type=script&lang=js"
export * from "./KakaoLogin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__